import script from "./StaticElement.vue?vue&type=script&lang=js"
export * from "./StaticElement.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__